// AdduserModel.js
import React, { useState } from "react";
import axios from "axios";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

function AdduserModel({ onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    status: "",
  });

  const [message, setMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarType, setSnackbarType] = useState("success");


  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "mobile") {
      const digitsOnly = value.replace(/\D/g, "");
      if (digitsOnly.length <= 10) {
        setFormData((prev) => ({ ...prev, [name]: digitsOnly }));
      }
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const { name, mobile, status } = formData;

    if (!name || !mobile || status === "") {
      setMessage("Please fill in all fields.");
      setSnackbarType("error");
      setSnackbarOpen(true);
      return;
    }

    if (mobile.length !== 10) {
      setMessage("Mobile number must be exactly 10 digits.");
      setSnackbarType("error");
      setSnackbarOpen(true);
      return;
    }

    try {
      const data = new FormData();
      data.append("name", name);
      data.append("phone", `+91${mobile}`);
      data.append("status", parseInt(status));

      const token = localStorage.getItem("access_token");

      if (!token) {
        setMessage("Access token not found. Please log in again.");
        setSnackbarType("error");
        setSnackbarOpen(true);
        return;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/add-user`,
        data,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success === false) {
        setMessage(response.data.message);
        setSnackbarType("error");
        setSnackbarOpen(true);
        return;
      }

      setMessage("User added successfully!");
      setSnackbarType("success");
      setSnackbarOpen(true);
      setFormData({ name: "", mobile: "", status: "" });

      if (onSuccess) onSuccess();

      setTimeout(() => {
        setMessage("");
        setSnackbarOpen(false);
        onClose();
      }, 1000);
    } catch (error) {
      if (error.response?.data?.message) {
        setMessage(error.response.data.message);

      } else {
        setMessage("Failed to add user. Please try again.");
      }
      setSnackbarType("error");
      setSnackbarOpen(true);
    }
  };
  const handleSnackbarClose = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  return (
    <MDBox component="form" onSubmit={handleSubmit} p={3} position="relative">
      <div
        onClick={onClose}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          cursor: "pointer",
          fontSize: "20px",
          fontWeight: "bold",
          color: "#999",
        }}
        title="Close"
      >
        &times;
      </div>

      <MDTypography variant="h5" fontWeight="medium" mb={3}>
        Add User
      </MDTypography>

      <MDBox mb={2}>
        <MDInput
          label="Name"
          name="name"
          fullWidth
          value={formData.name}
          onChange={handleChange}
        />
      </MDBox>

      <MDBox mb={2}>
        <MDInput
          type="text"
          label="Mobile"
          name="mobile"
          fullWidth
          value={formData.mobile}
          onChange={handleChange}
        />
      </MDBox>

      <MDBox mb={2}>
        <MDTypography variant="button" fontWeight="regular" display="block" mb={1}>
          Status
        </MDTypography>
        <select
          name="status"
          value={formData.status}
          onChange={handleChange}
          style={{
            width: "100%",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            backgroundColor: "#fff",
          }}
        >
          <option value="">Select status</option>
          <option value="1">Active</option>
          <option value="0">Inactive</option>
        </select>
      </MDBox>

      {/* {message && (
        <MDTypography
          variant="caption"
          color={message.toLowerCase().includes("success") ? "success" : "error"}
          display="block"
          mb={2}
        >
          {message}
        </MDTypography>
      )} */}

      <MDBox mt={4} mb={1}>
        <MDButton variant="gradient" color="info" type="submit" fullWidth>
          Add User
        </MDButton>
      </MDBox>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarType}
          sx={{ width: "100%" }}
        >
          {message}
        </MuiAlert>
      </Snackbar>
    </MDBox>
  );
}

export default AdduserModel;
